<script setup>
const props = defineProps({
  type: {
    type: String,
    required: true
  },
  vars: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['ok', 'cancel'])

function handleOk() {
  emit('ok',{value:true})
}

function handleCancel() {
  emit('cancel')
}
</script>

<template>
  <div :class="type + '-inner'">
    <div v-if="vars.title" :class="type + '-title'">
      <h1>{{ vars.title }}</h1>
    </div>

    <div :class="type + '-main'">
      <div :class="type + '-main-inner'">
        <p>{{ vars.lead }}</p>
      </div>

      <div :class="type + '-btns'">
        <!-- OK -->
        <p class="btn">
          <a href="#" @click.prevent="handleOk">
            {{ vars.okText ?? 'OK' }}
          </a>
        </p>

        <!-- Cancel -->
        <p class="btn">
          <a href="#" @click.prevent="handleCancel">
            {{ vars.cancelText ?? 'キャンセル' }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
